import React, { useState } from 'react'
import { expand } from '../../Images/Icons';
import ReactApexChart from "react-apexcharts";
import ChartSection from '../Statistic/ChartSection';
import { useNavigate } from 'react-router-dom';
import { back } from '../../Images/Icons';
import ChartSectionFull from './ChartSection';
const LineChatPage = () => {
    
    const navigation = useNavigate(); 
    const [state, setNewState] = useState({
        series: [{
            name: 'PV output',
            color: '#0FC637',
            data: [null, null, null, null, null, null, null]
        }, {
            name: 'Total consumption',
            color:'#F66453',
            data: [11, 32, 30, 32, 34, 40, 35],
            hidden: true
        }, {
            name: 'Consumed from PV',
            color:'#3698FF',
            data: [31, 40, 28, 51, 42, 45, 39]
        }, {
            name: 'Battery (charge)',
            color:'#D090D6',
            data: [null, null, null, null, null, null, null]
        }, {
            name: 'Battery (discharge)',
            color:'#FC891F',
            data: [null, null, null, null, null, null, null]
        }],
        options: {
            chart: {
                width: '100%'
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                type: 'datetime',
                categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy HH:mm'
                },
            },

        },
        
        
        
    });

    const setState = data => {
        setNewState(prev => ({ ...prev, ...data }))
    }

    const { series, options } = state;
    
    const onGoback = () => {
        navigation(-1);
    }

    return (
        <div>
            <div className="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>Statistic</div>
                </div>
            </div>
            <div className="page-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1, background: '#F2F5FA' }}>
                <div>
                    <div style={{ margin: 20, background: 'white', borderRadius: 12, padding: 12 }}>
                        {/* Energy Management */}
                        <div style={{}}>
                            <div style={{ fontSize: 16, fontWeight: 500, color: '#161616', textAlign: 'center' }}>Energy Management</div>

                            {/*Chart*/}
                            <ChartSectionFull />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LineChatPage